import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Position } from '@xyflow/react';
import ActionHandle from '../ActionHandle';
import { ActionStartHometimerNodeType } from '../types';
import BaseNode from '../BaseNode';

export const ActionStartHomeTimerNode = memo(
  ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data,
    selected,
    disabled,
  }: {
    data: ActionStartHometimerNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    return (
      <BaseNode
        selected={selected ?? false}
        type="action"
        isValid={data.isValid}
        disabled={disabled}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Start Hometimer',
              id: 'DPCwdW',
            })}
          </T>
          <T body2>
            {intl.formatMessage({
              defaultMessage: 'Hometimer',
              id: 'xfHfR4',
            })}
          </T>
        </Flex>
        <ActionHandle
          type="target"
          position={Position.Left}
          disabled={disabled}
        />
        <ActionHandle
          type="source"
          position={Position.Right}
          disabled={disabled}
        />
      </BaseNode>
    );
  },
);
